export const fieldCommonClasses =
  'flex flex-col md:flex-row gap-3 md:gap-5 md:items-center';
export const labelCommonClasses =
  'inline-block font-bold font-ubuntu text-clr-gray w-full text-base text-left md:text-right h-fit self-center';
export const labelWidthClass = 'w-full md:w-1/2';
